import commonScripts from './partials/common';

commonScripts();
